import React from 'react';

const TMPLogoFull = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="255"
      height="19.728"
      viewBox="0 0 255 19.728"
      {...props}
    >
      <title>The Mom Project</title>
      <g transform="translate(-390 -554)">
        <g transform="translate(390 554)">
          <path
            fill="currentColor"
            d="M217.282,15.533l-7.132-8.91V22.692h1.56v-11.7l5.572,7.107,5.572-7.107v11.7H224.5V6.54Z"
            transform="translate(-102.551 -3.274)"
          />
          <path
            fill="currentColor"
            d="M125.037,15.533l-7.127-8.91V22.692h1.56v-11.7l5.567,7.107,5.572-7.107v11.7h1.643V6.54Z"
            transform="translate(-58.121 -3.274)"
          />
          <path
            fill="currentColor"
            d="M130.929,20.206h1.42V1.38h-4.178L122.6,8.73l-5.567-7.35H112.85V20.206h1.508V2.717H115.8l6.8,8.662,6.878-8.662h1.451Z"
            transform="translate(-55.684 -0.789)"
          />
          <path
            fill="currentColor"
            d="M223.179,20.206h1.42V1.38h-4.178L214.85,8.73l-5.572-7.35H205.1V20.206h1.5V2.717h1.451l6.8,8.662,6.878-8.662h1.451Z"
            transform="translate(-100.119 -0.789)"
          />
          <path
            fill="currentColor"
            d="M171.05,18.373a5.821,5.821,0,1,1,.01,0h0m.026-13.093a7.257,7.257,0,1,0,7.257,7.257,7.257,7.257,0,0,0-7.257-7.257"
            transform="translate(-80.24 -2.668)"
          />
          <path
            fill="currentColor"
            d="M168.8,18.6a8.325,8.325,0,1,1,8.293-8.356V10.3A8.324,8.324,0,0,1,168.8,18.6M168.8.57a9.693,9.693,0,1,0,9.693,9.693h0A9.719,9.719,0,0,0,168.8.57"
            transform="translate(-77.966 -0.399)"
          />
          <path
            fill="currentColor"
            d="M12.247,4.514V19.94H8.536V4.514H2.56V1.02H18.224V4.514Z"
            transform="translate(-2.56 -0.616)"
          />
          <path
            fill="currentColor"
            d="M51.472,19.94V12.092H43.225V19.94H39.54V1.02h3.685v7.6h8.247V1.02h3.706V19.94Z"
            transform="translate(-20.372 -0.616)"
          />
          <path
            fill="currentColor"
            d="M79.82,19.94V1.02H91.669V4.488H83.5V8.811h7.4v3.281H83.5v4.38h8.169V19.94Z"
            transform="translate(-39.774 -0.616)"
          />
          <path
            fill="currentColor"
            d="M261.689,9.63a2.643,2.643,0,0,0,2.965-2.7,2.662,2.662,0,0,0-2.965-2.721h-2.908V9.63Zm-2.934,3.177V19.93H255.07V1h7.075c3.737,0,6.22,2.483,6.22,5.9s-2.478,5.9-6.22,5.9Z"
            transform="translate(-124.188 -0.606)"
          />
          <path
            fill="currentColor"
            d="M294.568,9.47c1.866,0,2.96-1.068,2.96-2.618s-1.094-2.638-2.96-2.638h-3.012V9.47ZM293.5,12.642h-1.944V19.93H287.85V1h7.391a5.68,5.68,0,0,1,6.033,5.816,5.37,5.37,0,0,1-4.017,5.375l4.058,7.739h-4.11Z"
            transform="translate(-139.977 -0.606)"
          />
          <path
            fill="currentColor"
            d="M329.147,16.392c2.939,0,5.924-2.032,5.924-6.3s-2.986-6.3-5.924-6.3-5.893,2.027-5.893,6.3,2.986,6.3,5.893,6.3m0-16.152a9.565,9.565,0,0,1,9.77,9.88,9.73,9.73,0,1,1-19.458,0A9.536,9.536,0,0,1,329.147.24"
            transform="translate(-155.203 -0.24)"
          />
          <path
            fill="currentColor"
            d="M361.726,12.922h3.55v1.094c0,1.949,1.12,2.83,2.592,2.83a2.505,2.505,0,0,0,2.509-2.747V1h3.68V14.088a6.049,6.049,0,0,1-5.874,6.219c-.1,0-.192,0-.289,0a5.82,5.82,0,0,1-6.194-6.163Z"
            transform="translate(-175.549 -0.606)"
          />
          <path
            fill="currentColor"
            d="M395.34,19.94V1.02h11.849V4.488H399.02V8.811h7.391v3.281H399.02v4.38h8.169V19.94Z"
            transform="translate(-191.753 -0.616)"
          />
          <path
            fill="currentColor"
            d="M424.8,10.12A9.556,9.556,0,0,1,434.436.24c5.23,0,7.925,3.2,8.672,6.272l-3.468,1.1a4.941,4.941,0,0,0-5.183-3.82c-2.83,0-5.816,2.032-5.816,6.329a5.812,5.812,0,0,0,5.867,6.22,5.256,5.256,0,0,0,5.313-3.867l3.442,1.037a8.6,8.6,0,0,1-8.755,6.427,9.431,9.431,0,0,1-9.687-9.849"
            transform="translate(-205.943 -0.24)"
          />
          <path
            fill="currentColor"
            d="M474,4.514V19.94h-3.711V4.514H464.31V1.02h15.664V4.514Z"
            transform="translate(-224.974 -0.616)"
          />
        </g>
      </g>
    </svg>
  );
};

export default TMPLogoFull;
